<div class="toast-container" [class.toast-success]="toast.type === 'success'" [class.toast-error]="toast.type === 'error'" [class.toast-warning]="toast.type === 'warning'" [class.toast-info]="toast.type === 'info'">
  <div class="toast-content">
    <mat-icon class="toast-icon" [style.color]="iconColor">{{ icon }}</mat-icon>
    <span class="toast-message">{{ toast.message }}</span>
  </div>
  <div class="toast-actions">
    <button
      *ngIf="toast.action"
      mat-button
      class="toast-action"
      (click)="onAction()"
    >
      {{ toast.action }}
    </button>
    <button mat-icon-button class="toast-close" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
